export const UploadIcon = ({ fileName }: { fileName: string }) => {
  return (
    <div className='flex items-center justify-center'>
      <div className='text-primary dark:bg-secondary-50/10 rounded-default bg-sky-100 p-2 text-sm'>
        {fileName.split('.').reverse()[0].toUpperCase()}
      </div>
    </div>
  );
};
